import type { FC } from 'react';
import { Radio, RadioGroup } from '@chakra-ui/react';
import { useIntl } from 'react-intl';
import { getSearchSortItems } from '../../../utils/search-page-utils';
import type { UseSearchResult } from '../../../hooks/use-search';

interface Props {
    search: UseSearchResult;
}

export const SortFilterSection: FC<Props> = ({ search: { searchParams, onChangeParam } }) => {
    const intl = useIntl();

    const sortItems = getSearchSortItems(intl);

    const currentSort = searchParams.sort
        ? sortItems.find((item) => item.value === searchParams.sort)
        : sortItems[0];

    const handleSortChange = (value: string): void => {
        onChangeParam('sort', value);
    };

    return (
        <RadioGroup
            onChange={handleSortChange}
            value={currentSort?.value}
            display="flex"
            flexDirection="column"
            gap={4}
        >
            {sortItems.map((item) => (
                <Radio
                    data-testid={`sort-filter-${item.id}`}
                    value={item.value}
                    key={item.id}
                    size="base"
                >
                    {item.label}
                </Radio>
            ))}
        </RadioGroup>
    );
};
